import {createSelector} from 'reselect'

const controlledDocsSelector = state => state.controlledDocs

export const getControlledDocsData = createSelector(
    controlledDocsSelector,
    data => data
)
